import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import { useState } from "react";
import useAPI from "../../api/hooks/useAPI";
import useColors from "../../api/hooks/useColors";

const RefreshLimitsButton = ({}) => {
  const [open, setOpen] = useState(false);
  const [customerIdToRefresh, setCustomerIdToRefresh] = useState("");
  const { refreshLimitsCache } = useAPI();
  const colors = useColors();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSave = () => {
    refreshLimitsCache(customerIdToRefresh);
    setOpen(false);
  };

  return (
    <>
      <Button
        variant="outlined"
        sx={{
          backgroundColor: colors.info_lighter,
          textTransform: "none",
          color: colors.common_black,
        }}
        onClick={handleClickOpen}
      >
        Refresh Limits Cache
      </Button>
      <Dialog
        onKeyUp={(e) => {
          const ENTER = "Enter";

          if (e.key === ENTER) {
            handleSave();
            handleClose();
          }
        }}
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Enter Customer ID</DialogTitle>
        <DialogContent>
          <DialogContentText>
            To refresh the limits cache, please enter the customer ID here.
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Customer ID"
            type="text"
            fullWidth
            onChange={(e) => setCustomerIdToRefresh(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleSave}>Go</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default RefreshLimitsButton;
